import StyleInput from "../../../components/Button/Input";
import StyleSelect from "../../../components/Button/AutoComplete";
import StyleDatePicker from "../../../components/Button/DatePicker";
import tabletrans from "../../../translate/tables";
import { useState, useEffect, useCallback } from "react";
import NewStyleSelect from "../../../components/Button/NewStyleSelect";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox, Typography } from "@mui/material";
function ProductFilters(props) {
  const lang = props.lang;
  const catList = props.catList;
  const [query, setQuery] = useState(props.currentFilters?.title || "");
  const [selectedCat, setSelectedCat] = useState(null);
  const [MainProduct, setMainProduct] = useState(false);
  const handleFilterChange = useCallback(
    (property, value) => {
      const newValue = value ? (value._id ? value._id : value) : "";

      props.setFilters((prevState) => {
        const newState = {
          ...prevState,
          [property]: newValue,
        };

        props.updateUrlWithFilters(newState);

        return newState;
      });
    },
    [props.setFilters, props.updateUrlWithFilters],
  );

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      props.setFilters((prevState) => {
        const newState = { ...prevState, title: query };

        props.updateUrlWithFilters(newState);

        return newState;
      });
    }, 1000);

    return () => clearTimeout(timeOutId);
  }, [query]);

  useEffect(() => {
    if (catList?.length > 0 && props.currentFilters.catid) {
      console.log("true");
      const found = catList.find(
        (opt) => String(opt.catCode) === String(props.currentFilters.catid),
      );
      if (found) {
        console.log("found");
        setSelectedCat(found); // 👈 مستقیم همون آبجکت catList
      }
    }
  }, [catList, props.currentFilters.catid]);
  const MainProductFilter = () => {
    setMainProduct(!MainProduct);
  };
  return (
    <div className="user-filter" style={{ direction: "ltr" }}>
      <div className="serach-input" style={{ flexDirection: "row-reverse" }}>
        <StyleInput
          title={tabletrans.productTitle[lang.lang]}
          direction={props.lang.dir}
          defaultValue={props.currentFilters.title}
          action={(e) => setQuery(e)}
        />
        <StyleSelect
          title={"موجودی"}
          direction={props.lang.dir}
          label="title"
          options={[
            { title: "موجود", value: "1" },
            { title: "ناموجود", value: "2" },
          ]}
          defaultValue={[
            { title: "موجود", value: "1" },
            { title: "ناموجود", value: "2" },
          ].find((opt) => opt.value === props.currentFilters.exist)}
          action={(e) => handleFilterChange("exist", e ? e.value : "")}
        />
        <StyleSelect
          title={"تصویر"}
          direction={props.lang.dir}
          label="title"
          options={[
            { title: "تصویر ندارند", value: "true" },
            { title: "تصویر دارد", value: "false" },
          ]}
          defaultValue={[
            { title: "تصویر ندارند", value: "true" },
            { title: "تصویر دارد", value: "false" },
          ].find((opt) => opt.value === props.currentFilters.noImage)}
          action={(e) => handleFilterChange("noImage", e ? e.value : "")}
        />
        <NewStyleSelect
          title=" دسته‌بندی"
          direction={props.lang.dir}
          label="title"
          options={catList}
          value={selectedCat}
          action={(e) => {
            setSelectedCat(e);
            handleFilterChange("catid", e ? String(e.catCode) : "");
          }}
        />
        <StyleSelect
          title={"نمایش"}
          direction={props.lang.dir}
          label="title"
          options={[
            { title: "اصلی", value: "true" },
            { title: "فرعی", value: "false" },
          ]}
          defaultValue={[
            { title: "اصلی", value: "true" },
            { title: "فرعی", value: "false" },
          ].find((opt) => opt.value === props.currentFilters.master)}
          action={(e) => handleFilterChange("master", e ? e.value : "")}
        />
        {/* <FormGroup>
          <FormControlLabel
            sx={{ margin: "0px" }}
            control={
              <Switch
                checked={props.currentFilters.isShemsh}
                onChange={(e) =>
                  handleFilterChange("isShemsh", e ? e.target.checked : "")
                }
              />
            }
            label="شمش"
          />
        </FormGroup> */}
        <FormGroup>
          <FormControlLabel
            sx={{ margin: "0px", fontSize: "1.2rem" }}
            control={
              <Checkbox
                checked={props.currentFilters.isShemsh}
                onChange={(e) =>
                  handleFilterChange("isShemsh", e.target.checked)
                }
              />
            }
            label={
              <Typography
                component="span"
                sx={{
                  fontSize: "1.2rem",
                  marginRight: ".5rem",
                  fontWeight: "800",
                }}
              >
                شمش
              </Typography>
            }
          />
        </FormGroup>
        <FormGroup>
          <FormControlLabel
            sx={{ margin: "0px", fontSize: "1.2rem" }}
            control={
              <Checkbox
                checked={props.currentFilters.isSelected}
                onChange={(e) =>
                  handleFilterChange("isSelected", e.target.checked)
                }
              />
            }
            label={
              <Typography
                component="span"
                sx={{
                  fontSize: ".8rem",
                  marginRight: ".5rem",
                  fontWeight: "800",
                  whiteSpace: "nowrap",
                }}
              >
                محصولات وبسایت
              </Typography>
            }
          />
        </FormGroup>
        <FormGroup>
          <FormControlLabel
            sx={{ margin: "0px", fontSize: "1.2rem" }}
            control={
              <Checkbox
                checked={props.currentFilters.isDiscount || false}
                onChange={(e) =>
                  handleFilterChange("isDiscount", e.target.checked)
                }
              />
            }
            label={
              <Typography
                component="span"
                sx={{
                  fontSize: ".8rem",
                  marginRight: ".5rem",
                  fontWeight: "800",
                  whiteSpace: "nowrap",
                }}
              >
                دارای تخفیف
              </Typography>
            }
          />
        </FormGroup>
      </div>
    </div>
  );
}
export default ProductFilters;
